/* Publish by EComposer at 2026-10-13 15:26:14*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0gbvh7viqizu"]=  window.__ectimmers["ecom-0gbvh7viqizu"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-0gbvh7viqizu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0gbvh7viqizu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fobq0dvn0b9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fobq0dvn0b9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99vn0l9702').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99vn0l9702', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zd9v02gfxnm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zd9v02gfxnm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ommx2dzrhi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ommx2dzrhi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2e6h6xxb4jo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2e6h6xxb4jo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p81p36bbhjp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p81p36bbhjp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4takml14ini').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4takml14ini', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7dg620griz4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7dg620griz4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jt27yq4m49e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jt27yq4m49e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-staq58oksf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-staq58oksf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qtlk2cxmxu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qtlk2cxmxu', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-q9890yeonss"]=  window.__ectimmers["ecom-q9890yeonss"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-q9890yeonss"]["ux7ltnip4"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-q9890yeonss').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q9890yeonss', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8u4fevtq6dh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8u4fevtq6dh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-79liv0hbuog').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-79liv0hbuog', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3wm0imrnhnz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3wm0imrnhnz', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7nn50ittzxb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7nn50ittzxb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vvq1vixl06').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vvq1vixl06', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0a7b0vwh2grm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0a7b0vwh2grm', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g6qt4bxk00b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g6qt4bxk00b', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wzrqe2t53q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wzrqe2t53q', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}